"use strict";
var appn;
(function (appn) {
    var select;
    (function (select_1) {
        class Args {
            constructor() {
                this.selector = appn.emptyString;
                this.minimumResultsForSearch = appn.emptyString;
                this.isIconSelect = false;
                this.isFASelect = false;
                this.isIconButtonSelect = false;
                this.isIconTextSelect = false;
                this.isHierarchical = false;
                this.omitWidth = false;
            }
        }
        let _initArgs;
        const _hierarchyData = new Map();
        const _expandedNodes = new Set();
        let _hierarchicalToggleHandler = null;
        function handleHierarchicalToggleEvent(e) {
            const target = e.target;
            const toggle = target.closest('.select2-dropdown .expand-toggle');
            if (!toggle)
                return;
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            const $toggle = $(toggle);
            const $option = $toggle.closest('.select2-results__option');
            const $hierarchical = $option.find('.hierarchical-option');
            const value = $hierarchical.data('value');
            if (!value)
                return;
            const node = _hierarchyData.get(value);
            if (!node || !node.hasChildren)
                return;
            if (_expandedNodes.has(value)) {
                collapseNode(value);
                $toggle.removeClass('expanded');
            }
            else {
                expandNode(value);
                $toggle.addClass('expanded');
            }
            updateHierarchicalVisibility();
        }
        function buildHierarchyData($select) {
            _hierarchyData.clear();
            _expandedNodes.clear();
            const options = $select.find('option').toArray();
            const valueToOption = new Map();
            options.forEach(opt => {
                const $opt = $(opt);
                const value = $opt.val();
                if (value) {
                    valueToOption.set(value, opt);
                }
            });
            options.forEach(opt => {
                const $opt = $(opt);
                const value = $opt.val();
                if (!value)
                    return;
                const parentValue = $opt.data('parent-value');
                let depth = 0;
                let currentParent = parentValue;
                const visited = new Set();
                while (currentParent && !visited.has(currentParent)) {
                    visited.add(currentParent);
                    depth++;
                    const parentOpt = valueToOption.get(currentParent);
                    if (parentOpt) {
                        currentParent = $(parentOpt).data('parent-value');
                    }
                    else {
                        break;
                    }
                }
                _hierarchyData.set(value, {
                    value: value,
                    parentValue: parentValue || null,
                    depth: depth,
                    hasChildren: false,
                    children: []
                });
            });
            _hierarchyData.forEach((node, value) => {
                if (node.parentValue) {
                    const parentNode = _hierarchyData.get(node.parentValue);
                    if (parentNode) {
                        parentNode.hasChildren = true;
                        parentNode.children.push(value);
                    }
                }
            });
        }
        function isNodeVisible(value) {
            const node = _hierarchyData.get(value);
            if (!node)
                return true;
            if (node.depth === 0)
                return true;
            let currentValue = node.parentValue;
            while (currentValue) {
                if (!_expandedNodes.has(currentValue))
                    return false;
                const parentNode = _hierarchyData.get(currentValue);
                currentValue = (parentNode === null || parentNode === void 0 ? void 0 : parentNode.parentValue) || null;
            }
            return true;
        }
        function getOptionElementByValue(value) {
            return $(`.select2-results__option`).filter(function () {
                return $(this).find('.hierarchical-option').data('value') === value;
            });
        }
        function expandNode(value) {
            const node = _hierarchyData.get(value);
            if (!node || !node.hasChildren)
                return;
            _expandedNodes.add(value);
            node.children.forEach(childValue => {
                const $childOption = getOptionElementByValue(childValue);
                $childOption.removeClass('hierarchical-hidden');
            });
        }
        function collapseNode(value) {
            const node = _hierarchyData.get(value);
            if (!node || !node.hasChildren)
                return;
            _expandedNodes.delete(value);
            function hideDescendants(parentValue) {
                const parentNode = _hierarchyData.get(parentValue);
                if (!parentNode)
                    return;
                parentNode.children.forEach(childValue => {
                    const $childOption = getOptionElementByValue(childValue);
                    $childOption.addClass('hierarchical-hidden');
                    hideDescendants(childValue);
                });
            }
            hideDescendants(value);
        }
        function expandAncestorsOfMatch(value) {
            var _a;
            const node = _hierarchyData.get(value);
            if (!node)
                return;
            let currentValue = node.parentValue;
            while (currentValue) {
                _expandedNodes.add(currentValue);
                currentValue = ((_a = _hierarchyData.get(currentValue)) === null || _a === void 0 ? void 0 : _a.parentValue) || null;
            }
        }
        function init(initArgs) {
            $(document).on('select2:open', (event) => {
                if (!event.target.multiple)
                    window.setTimeout(() => $('.select2-container--open .select2-search--dropdown .select2-search__field').last()[0].focus(), 0);
            });
            $(document).on('select2:open', (event) => {
                const target = event.target;
                const select2Data = $(target).data('select2');
                if (!select2Data || !select2Data.$dropdown)
                    return;
                window.requestAnimationFrame(() => {
                    var _a;
                    const containerRect = (_a = target.nextElementSibling) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
                    const dropdownWidth = select2Data.$dropdown.outerWidth() || 0;
                    const winWidth = $(window).width() || 0;
                    if (containerRect && dropdownWidth && containerRect.left + dropdownWidth > winWidth)
                        select2Data.$dropdown.css('left', Math.max(containerRect.right - dropdownWidth, 0) + 'px');
                });
            });
            if (!initArgs)
                initArgs = new Args();
            _initArgs = initArgs;
            if (!initArgs.hasOwnProperty('selector') || !initArgs.selector)
                initArgs.selector = 'select:not(.bootstrap-duallistbox-container select,select.multiselect,#iconControlTemplate .select-icons,.select2-noinit,select#iconsToDisplay)';
            if (!initArgs.hasOwnProperty('minimumResultsForSearch') || !initArgs.minimumResultsForSearch)
                initArgs.minimumResultsForSearch = '50';
            if (!initArgs.hasOwnProperty('omitWidth') || !initArgs.omitWidth)
                initArgs.omitWidth = false;
            const select2Options = {
                theme: 'bootstrap4',
                minimumResultsForSearch: initArgs.minimumResultsForSearch,
                width: initArgs.omitWidth ? '' : '100%',
                dropdownAutoWidth: true,
                dropdownCssClass: ":all:"
            };
            if (initArgs.hasOwnProperty('isIconSelect') && initArgs.isIconSelect) {
                select2Options.templateResult = formatStateIcons;
                select2Options.templateSelection = formatStateIcons;
                select2Options.minimumResultsForSearch = '200';
            }
            else if (initArgs.hasOwnProperty('isFASelect') && initArgs.isFASelect) {
                select2Options.templateResult = formatStateFAResult;
                select2Options.templateSelection = formatStateFA;
                select2Options.minimumResultsForSearch = '200';
                select2Options.escapeMarkup = function (m) {
                    return m;
                };
                select2Options.width = '50px';
            }
            else if (initArgs.hasOwnProperty('isIconButtonSelect') && initArgs.isIconButtonSelect) {
                select2Options.templateResult = formatStateIconButtonResult;
                select2Options.templateSelection = formatStateIconButtonSelection;
                select2Options.minimumResultsForSearch = 'Infinity';
                select2Options.width = 'auto';
                select2Options.escapeMarkup = function (m) {
                    return m;
                };
            }
            else if (initArgs.hasOwnProperty('isIconTextSelect') && initArgs.isIconTextSelect) {
                select2Options.templateResult = formatStateIconText;
                select2Options.templateSelection = formatStateIconText;
            }
            if ($(initArgs.selector).find('option').filter('[data-title]').length > 0) {
                select2Options.templateResult = formatStateOptionTitles;
                select2Options.templateSelection = formatStateOptionTitles;
                $(document).on('mouseenter', '.select2-results__option', function () {
                    $('.select2-results__option span[title]').smallipop({ preferredPosition: 'right', theme: 'black', popupOffset: 100 });
                    $('li.select2-results__option').removeAttr('data-original-title').removeAttr('title');
                });
                $(document).on('select2:close select2:select', initArgs.selector, function (e) {
                    $('.smallipop-instance').hide();
                });
            }
            $(initArgs.selector).each((index, select) => {
                if ($(select).attr('multiple'))
                    removeDefaultFromMultiselect($(select));
            });
            $(initArgs.selector).select2(select2Options);
            copyOriginalSelectsAttrs(initArgs);
            if (initArgs.isIconSelect) {
                const select2 = $(initArgs.selector).next('.select2');
                select2.removeClass('select2-appnIcons').addClass('select2-appnIcons');
            }
            if (initArgs.isIconButtonSelect) {
                $(initArgs.selector).each(function () {
                    const select2 = $(this).next('.select2');
                    select2.addClass('select2-iconButton');
                });
            }
            if (initArgs.hasOwnProperty('onSelectCallback') && initArgs.onSelectCallback)
                $(initArgs.selector).on('select2:select', function (e) {
                    initArgs.onSelectCallback(e);
                });
            if (initArgs.hasOwnProperty('onOpenCallback') && initArgs.onOpenCallback)
                $(initArgs.selector).on('select2:open', function (e) {
                    setTimeout(function () {
                        initArgs.onOpenCallback(e);
                    }, 250);
                });
            $(document).on('mouseenter', '.select2-selection__rendered', function () {
                $(this).removeAttr('data-original-title').removeAttr('title');
            });
        }
        select_1.init = init;
        function initForDesign(initArgs) {
            const select2Options = {
                theme: 'bootstrap4',
                minimumResultsForSearch: initArgs.minimumResultsForSearch || '50',
                width: initArgs.omitWidth ? '' : '100%',
                dropdownAutoWidth: true,
                dropdownCssClass: ":all:"
            };
            if (initArgs.elements.find('option').filter('[data-title]').length > 0) {
                select2Options.templateResult = formatStateOptionTitles;
                select2Options.templateSelection = formatStateOptionTitles;
            }
            if (initArgs.isIconButtonSelect) {
                select2Options.templateResult = formatStateIconButtonResult;
                select2Options.templateSelection = formatStateIconButtonSelection;
                select2Options.minimumResultsForSearch = 'Infinity';
                select2Options.width = 'auto';
                select2Options.escapeMarkup = function (m) {
                    return m;
                };
            }
            if (initArgs.isIconTextSelect) {
                select2Options.templateResult = formatStateIconText;
                select2Options.templateSelection = formatStateIconText;
            }
            if (initArgs.isHierarchical) {
                select2Options.templateResult = formatStateHierarchical;
                select2Options.matcher = hierarchicalMatcher;
            }
            initArgs.elements.each((index, select) => {
                const $select = $(select);
                if ($select.hasClass('select2-hidden-accessible')) {
                    return;
                }
                if ($select.attr('multiple')) {
                    removeDefaultFromMultiselect($select);
                }
                if (initArgs.isHierarchical) {
                    buildHierarchyData($select);
                }
                $select.select2(select2Options);
                if (initArgs.isHierarchical) {
                    bindHierarchicalEvents($select);
                }
                const newSelect2 = $select.next('.select2');
                if (!newSelect2 || !newSelect2.length) {
                    return;
                }
                if ($select.hasClass('form-control-sm'))
                    newSelect2.addClass('select2-sm');
                if (initArgs.isIconButtonSelect)
                    newSelect2.addClass('select2-iconButton');
                if ($select.prop('id')) {
                    const newId = `${$select.prop('id')}-select2`;
                    newSelect2.prop('id', newId);
                }
                if ($select.hasClass('float-right'))
                    newSelect2.addClass('float-right');
                if ($select.hasClass('float-left'))
                    newSelect2.addClass('float-left');
                if ($select.hasClass('d-none'))
                    newSelect2.addClass('d-none');
            });
        }
        select_1.initForDesign = initForDesign;
        function destroy(selector) {
            if ($(selector).attr('data-select2-id')) {
                $(selector).select2('destroy');
                $(selector).removeAttr('data-select2-id');
            }
        }
        select_1.destroy = destroy;
        function formatStateIcons(state) {
            if (!state.id)
                return state.text;
            const $state = $(`<img src="${state.element.dataset.imagesrc}" class="img-select2" />`);
            if (_initArgs.hasOwnProperty('isIconSelect') && _initArgs.isIconSelect)
                $state.append($(`<span class="img-select2-text">${state.element.value}</span>`));
            return $state;
        }
        function formatStateFA(icon) {
            if (!icon.id)
                return icon.text;
            const iconEl = appn.elementBuilder.createElement('i', ['fa', $(icon.element).attr('class'), 'fa-lg', 'fa-fw'], undefined, [['style', $(icon.element).attr('style')]]);
            if ($(icon.element).attr('data-parent'))
                $(iconEl).attr('data-parent', $(icon.element).attr('data-parent'));
            const span = appn.elementBuilder.createElement('span');
            span.append(iconEl);
            return $(span);
        }
        function formatStateFAResult(icon) {
            if (!icon.id)
                return icon.text;
            const iconEl = appn.elementBuilder.createElement('i', ['fa', $(icon.element).attr('class'), 'fa-lg', 'fa-fw'], undefined, [['style', $(icon.element).attr('style')]]);
            if ($(icon.element).attr('data-parent'))
                $(iconEl).attr('data-parent', $(icon.element).attr('data-parent'));
            const span = appn.elementBuilder.createElement('span', 'select2-fa_result');
            span.append(iconEl);
            span.append(` ${icon.text}`);
            return $(span);
        }
        function formatStateIconButtonResult(state) {
            if (!state.id)
                return state.text;
            const icon = $(state.element).data('icon');
            const $state = $(`<span><i class="fa ${icon}"></i> ${state.text}</span>`);
            applyOptionContainerClass($state, state);
            return $state;
        }
        function formatStateIconButtonSelection(state) {
            if (!state.id)
                return state.text;
            const icon = $(state.element).data('icon');
            return $(`<i class="fa ${icon}"></i>`);
        }
        function buildOptionIcon(state) {
            const iconClass = $(state.element).data('icon-class');
            if (iconClass)
                return $(`<i class="${iconClass} select2-option-icon"></i>`);
            const iconUrl = $(state.element).data('icon-url');
            if (!iconUrl)
                return null;
            return $('<img>', {
                src: iconUrl,
                class: 'select2-option-icon',
                title: $(state.element).data('icon-tooltip') || ''
            });
        }
        function formatStateIconText(state) {
            if (!state.id)
                return state.text;
            const $icon = buildOptionIcon(state);
            if (!$icon)
                return state.text;
            const $state = $('<span>').append($icon).append(` ${state.text}`);
            applyOptionContainerClass($state, state);
            return $state;
        }
        function applyOptionContainerClass($container, state) {
            const containerClass = $(state.element).data('container-class');
            if (containerClass)
                $container.addClass(containerClass);
        }
        function formatStateHierarchical(state) {
            if (!state.id)
                return state.text;
            const value = state.id;
            const node = _hierarchyData.get(value);
            const depth = (node === null || node === void 0 ? void 0 : node.depth) || 0;
            const hasChildren = (node === null || node === void 0 ? void 0 : node.hasChildren) || false;
            const isExpanded = _expandedNodes.has(value);
            const $container = $('<span>', {
                class: `hierarchical-option depth-${depth}`,
                'data-value': value,
                'data-depth': depth
            });
            applyOptionContainerClass($container, state);
            const $icon = buildOptionIcon(state);
            if ($icon)
                $container.append($icon);
            $container.append(`<span class="option-text">${state.text}</span>`);
            if (hasChildren) {
                const $toggle = $('<span>', {
                    class: `expand-toggle ${isExpanded ? 'expanded' : ''}`,
                    html: '<i class="fa fa-chevron-right"></i>'
                });
                $container.append($toggle);
            }
            return $container;
        }
        function hierarchicalMatcher(params, data) {
            if ($.trim(params.term) === '') {
                return data;
            }
            if (!data.id) {
                return null;
            }
            const text = data.text.toUpperCase();
            const term = params.term.toUpperCase();
            if (text.indexOf(term) > -1) {
                expandAncestorsOfMatch(data.id);
                return data;
            }
            return null;
        }
        function bindHierarchicalEvents($select) {
            $select.on('select2:open', function () {
                setTimeout(function () {
                    autoExpandSelected($select);
                    updateHierarchicalVisibility();
                    updateToggleStates();
                }, 10);
            });
            $select.on('select2:closing', function () {
                _expandedNodes.clear();
            });
            if (!_hierarchicalToggleHandler) {
                _hierarchicalToggleHandler = handleHierarchicalToggleEvent;
                document.addEventListener('mouseup', _hierarchicalToggleHandler, true);
            }
        }
        function autoExpandSelected($select) {
            const selectedValue = $select.val();
            if (!selectedValue)
                return;
            const node = _hierarchyData.get(selectedValue);
            if (!node || node.depth === 0)
                return;
            expandAncestorsOfMatch(selectedValue);
        }
        function updateHierarchicalVisibility() {
            _hierarchyData.forEach((node, value) => {
                const $option = getOptionElementByValue(value);
                if ($option.length) {
                    if (isNodeVisible(value)) {
                        $option.removeClass('hierarchical-hidden');
                    }
                    else {
                        $option.addClass('hierarchical-hidden');
                    }
                }
            });
        }
        function updateToggleStates() {
            _hierarchyData.forEach((node, value) => {
                if (node.hasChildren) {
                    const $toggle = $('.select2-dropdown .expand-toggle').filter(function () {
                        return $(this).closest('.hierarchical-option').data('value') === value;
                    });
                    if (_expandedNodes.has(value)) {
                        $toggle.addClass('expanded');
                    }
                    else {
                        $toggle.removeClass('expanded');
                    }
                }
            });
        }
        function formatStateOptionTitles(state) {
            if (!state.id)
                return state.text;
            if (state.element.dataset.title)
                state.title = state.element.dataset.title;
            const $state = $(appn.elementBuilder.createElement('span', 'select2-span_result', undefined, [['title', state.element.dataset.title], ['value', state.id]], state.element.text));
            return $state;
        }
        function removeDefaultFromMultiselect(select) {
            select.find('option').each((index, option) => {
                if (!$(option).attr('value'))
                    select.find(option).eq(index).remove();
            });
        }
        function copyOriginalSelectsAttrs(initArgs) {
            $(initArgs.selector).each(function () {
                const newSelect2 = $(this).next('.select2');
                if (!newSelect2 || !newSelect2.length)
                    return true;
                if ($(this).hasClass('form-control-sm'))
                    newSelect2.removeClass('select2-sm').addClass('select2-sm');
                if ($(this).prop('id')) {
                    const newId = `${$(this).prop('id')}-select2`;
                    newSelect2.prop('id', newId);
                }
                if ($(this).hasClass('float-right'))
                    newSelect2.removeClass('float-right').addClass('float-right');
                if ($(this).hasClass('float-left'))
                    newSelect2.removeClass('float-left').addClass('float-left');
                if ($(this).hasClass('d-none'))
                    newSelect2.removeClass('d-none').addClass('d-none');
            });
        }
    })(select = appn.select || (appn.select = {}));
})(appn || (appn = {}));
